module.exports = __webpack_public_path__ + "assets/img/71c1-tj.svg";